import Vue from 'vue';
import DialogComponent from './ShareDialog.vue';
import {click_event} from '../../../tools/mgtv/analysis'
let instance;
import {add_lottery_chance} from '../../../api'
const defaultOptions = {
  value: true,
  overlay: true,
  lockOnScroll: true,
  closeOnClickOverlay: true,
  width: '5rem',
  height: '3.58rem',
  img: "//vipcdn.mgtv.com/upload/20180127/share_weixin2.png",
  callback: action => {
    instance[action === 'confirm' ? 'resolve' : 'reject'](action);
  }
};

let currentDefaultOptions = {
  ...defaultOptions
};

const initInstance = () => {
  const DialogConstructor = Vue.extend(DialogComponent);
  instance = new DialogConstructor({
    el: document.createElement('div')
  });

  instance.$on('input', value => {
    instance.value = value;
  });

  document.body.appendChild(instance.$el);
};

const Dialog = options => {
  return new Promise((resolve, reject) => {
    if (!instance) {
      initInstance();
    }

    Object.assign(instance, {
      resolve,
      reject,
      ...options
    });
  });
};

Dialog.show = options => {
  // setTimeout(add_lottery_chance,0);
  if (support_native_modal()) {
    console.log('native share modal')
    MgtvApi && MgtvApi.showShare();
    setTimeout(()=>{
      click_event('拉起原生分享');
    },0);
    return null;
  }
  setTimeout(()=>{
    click_event('拉起分享弹窗');
  },0);
  return Dialog({
    ...currentDefaultOptions,
    ...options
  })
}


Dialog.close = () => {
  instance.value = false;
};

Dialog.setDefaultOptions = (options = {}) => {
  currentDefaultOptions = {
    ...currentDefaultOptions,
    ...options
  };
};

Dialog.resetDefaultOptions = () => {
  currentDefaultOptions = {
    ...defaultOptions
  };
};

Vue.prototype.$share_dialog = Dialog;
window.$share_dialog = Dialog;


function support_native_modal() {
  if (window.gact.is_app) {
    if ((window.gact.is_iphone && window.$bus.device_info.appVersion >= '5.7.7') || (window.gact.is_android && window.$bus.device_info.appVersion >= '5.7.4')) {
      return true
    }
  }
  return false;
}

export default Dialog;
export {
  DialogComponent as Dialog
};



// WEBPACK FOOTER //
// ./src/components/Popups/ShareDialog/index.js